// extracted by mini-css-extract-plugin
module.exports = {"register-operating-data":"style_register-operating-data__2LfSt"};